import React, { useState } from 'react';
import { VendorTemplate } from '@hone-automation/common';
import APAgingReportConfigurationButton from './APAgingReportConfigurationButton';
import APAgingConfigurationModal from '../APAgingConfigurationModal/APAgingConfigurationModal';

interface APAgingReportConfigurationProps {
  currentReport: 'AP Aging' | VendorTemplate;
  onReportChange: (reportType: 'AP Aging' | VendorTemplate, configData?: { dateRange: number }) => void;
  configurationId?: string;
  limit?: number;
}

function APAgingReportConfiguration({
  currentReport,
  onReportChange,
  configurationId,
  limit,
}: APAgingReportConfigurationProps) {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const toggleModal = () => {
    setModalIsOpen(prevState => !prevState);
  };

  const handleConfigurationSubmit = () => {
    // Handle the configuration data
  };

  return (
    <>
      <APAgingReportConfigurationButton toggleModal={toggleModal} currentReport={currentReport} />
      {modalIsOpen && (
        <APAgingConfigurationModal
          isModalOpen={true}
          handleModalCloseRequest={toggleModal}
          onSubmit={handleConfigurationSubmit}
          onReportChange={onReportChange}
          defaultConfiguration={configurationId}
          defaultLimit={limit}
        />
      )}
    </>
  );
}

export default APAgingReportConfiguration;
